document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-video-id]');
  if (!trigger) return;
  var id = trigger.dataset.videoId;
  if (!/^[\w-]{11}$/.test(id)) return;
  var frame = document.createElement('iframe');
  frame.title = trigger.getAttribute('aria-label');
  frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
  frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  frame.allowFullscreen = true;
  trigger.replaceWith(frame);
});
var fpReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function updateHeroImage(video, playing) {
  var image = video.parentElement.querySelector('[data-hero-poster]');
  if (!image) return;
  if (!image.dataset.poster) image.dataset.poster = image.getAttribute('src');
  var source = playing ? image.dataset.animation : image.dataset.poster;
  if (image.getAttribute('src') !== source) image.src = source;
  image.dataset.animated = String(playing);
}
function useHeroImage(video) {
  clearTimeout(video.fpHeroDeadline);
  video.fpHeroDeadline = null;
  video.dataset.heroFallback = 'true';
  video.removeAttribute('data-alpha-ready');
  video.pause();
  updateHeroImage(video, video.dataset.inView === 'true' && !fpReducedMotion.matches && !document.hidden);
}
function verifyHeroAlpha(video) {
  if (video.dataset.heroFallback || video.dataset.alphaReady || video.readyState < 2) return;
  try {
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    var context = canvas.getContext('2d', { willReadFrequently:true });
    context.drawImage(video, 0, 0, 1, 1, 0, 0, 1, 1);
    if (context.getImageData(0, 0, 1, 1).data[3] === 0) {
      clearTimeout(video.fpHeroDeadline);
      video.fpHeroDeadline = null;
      video.dataset.alphaReady = 'true';
    }
    else useHeroImage(video);
  } catch (error) { useHeroImage(video); }
}
function updateViewportVideo(video) {
  if (video.dataset.heroFallback) {
    useHeroImage(video);
    return;
  }
  if (video.dataset.inView !== 'true' || fpReducedMotion.matches || document.hidden) {
    clearTimeout(video.fpHeroDeadline);
    video.fpHeroDeadline = null;
    video.pause();
    return;
  }
  if (video.hasAttribute('data-hero-animation') && !video.canPlayType('video/webm; codecs="vp9"')) {
    useHeroImage(video);
    return;
  }
  if (!video.dataset.sourceLoaded) {
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.sourceLoaded = 'true';
    video.load();
  }
  if (video.hasAttribute('data-hero-animation') && !video.dataset.alphaReady && !video.fpHeroDeadline) {
    video.fpHeroDeadline = setTimeout(function () {
      if (!video.dataset.alphaReady) useHeroImage(video);
    }, 4000);
  }
  video.play().catch(function (error) {
    if (video.hasAttribute('data-hero-animation') && error.name !== 'AbortError') useHeroImage(video);
  });
}
var fpVideoObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    entry.target.dataset.inView = String(entry.isIntersecting);
    updateViewportVideo(entry.target);
  });
}, { threshold:0.05 });
var fpIntroObserver = new IntersectionObserver(function (entries, observer) {
  entries.forEach(function (entry) {
    if (!entry.isIntersecting) return;
    var frame = entry.target;
    frame.src = frame.dataset.src;
    frame.removeAttribute('data-src');
    observer.unobserve(frame);
  });
}, { threshold:0.05 });
function initializeViewportMedia() {
  document.querySelectorAll('[data-hero-animation]:not([data-initialized]),[data-ambient]:not([data-initialized])').forEach(function (video) {
    video.dataset.initialized = 'true';
    if (video.hasAttribute('data-hero-animation')) {
      video.addEventListener('loadeddata', function () { verifyHeroAlpha(video); });
      video.addEventListener('playing', function () { verifyHeroAlpha(video); });
      video.addEventListener('error', function () {
        if (video.dataset.sourceLoaded) useHeroImage(video);
      });
      video.querySelectorAll('source').forEach(function (source) {
        source.addEventListener('error', function () {
          if (source.hasAttribute('src') && video.dataset.sourceLoaded) useHeroImage(video);
        });
      });
    }
    fpVideoObserver.observe(video);
  });
  document.querySelectorAll('[data-intro-video] iframe[data-src]').forEach(function (frame) { fpIntroObserver.observe(frame); });
}
function updateVisibleMedia() {
  document.querySelectorAll('[data-hero-animation],[data-ambient]').forEach(updateViewportVideo);
}
fpReducedMotion.addEventListener('change', updateVisibleMedia);
document.addEventListener('visibilitychange', updateVisibleMedia);
initializeViewportMedia();
document.addEventListener('shopify:section:load', initializeViewportMedia);
document.addEventListener('shopify:section:unload', function (event) {
  event.target.querySelectorAll('[data-hero-animation],[data-ambient]').forEach(function (video) {
    clearTimeout(video.fpHeroDeadline);
    video.pause();
    fpVideoObserver.unobserve(video);
  });
  event.target.querySelectorAll('[data-intro-video] iframe').forEach(function (frame) { fpIntroObserver.unobserve(frame); });
});

function demoYouTubeId(value) {
  try {
    var url = new URL(value);
    if (url.protocol !== 'https:') return null;
    var host = url.hostname.toLowerCase();
    var id;
    if (host === 'youtu.be') id = url.pathname.slice(1);
    else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
      var parts = url.pathname.split('/');
      if (url.pathname === '/watch') id = url.searchParams.get('v');
      else if (['embed', 'shorts', 'live'].includes(parts[1]) && parts.length === 3) id = parts[2];
    }
    return typeof id === 'string' && /^[\w-]{11}$/.test(id) ? id : null;
  } catch (_) { return null; }
}
function initializeDemoLinks() {
  document.querySelectorAll('[data-demo-url]').forEach(function (link) {
    var id = demoYouTubeId(link.href);
    if (!id) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.dataset.videoId = id;
    button.setAttribute('aria-label', link.getAttribute('aria-label'));
    while (link.firstChild) button.appendChild(link.firstChild);
    var placeholder = button.querySelector('[data-demo-placeholder]');
    if (placeholder) {
      var image = document.createElement('img');
      image.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      image.alt = link.dataset.demoTitle;
      image.width = 480;
      image.height = 270;
      image.loading = 'lazy';
      placeholder.replaceWith(image);
    }
    link.replaceWith(button);
  });
}
function initializeDemoCarousels() {
  initializeDemoLinks();
  document.querySelectorAll('[data-fp-carousel]').forEach(function (carousel) {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    var track = carousel.querySelector('[data-carousel-track]');
    var cards = Array.from(track.querySelectorAll('article'));
    var previous = carousel.querySelector('[data-carousel-step="-1"]');
    var next = carousel.querySelector('[data-carousel-step="1"]');
    var count = carousel.querySelector('[data-carousel-count]');
    var pending;
    cards.forEach(function (card, index) {
      card.setAttribute('aria-roledescription', carousel.dataset.labelRole);
      card.setAttribute('aria-label', carousel.dataset.labelSlide.replace('%index%', index + 1).replace('%total%', cards.length));
    });
    function update() {
      pending = null;
      var bounds = track.getBoundingClientRect();
      var visible = cards.map(function (card, index) {
        var box = card.getBoundingClientRect();
        return Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left) >= box.width * 0.5 ? index + 1 : null;
      }).filter(Boolean);
      var first = visible[0] || 1;
      var last = visible[visible.length - 1] || first;
      var label = first === last ? String(first) : first + '-' + last;
      var message = (cards.length === 1 ? carousel.dataset.labelRangeOne : carousel.dataset.labelRangeOther).replace('%range%', label).replace('%count%', cards.length);
      if (count.textContent !== message) count.textContent = message;
      var overflow = track.scrollWidth > track.clientWidth + 2;
      previous.disabled = !overflow || track.scrollLeft <= 2;
      next.disabled = !overflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    function schedule() {
      if (!pending) pending = requestAnimationFrame(update);
    }
    function move(step, edge) {
      if (!cards.length) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var stride = cards[0].getBoundingClientRect().width + gap;
      var target = edge === 'start' ? 0 : edge === 'end' ? track.scrollWidth : (Math.round(track.scrollLeft / stride) + step) * stride;
      track.scrollTo({ left: target, behavior: fpReducedMotion.matches ? 'instant' : 'smooth' });
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1, event.key === 'Home' ? 'start' : event.key === 'End' ? 'end' : null);
    });
    var observer = new ResizeObserver(schedule);
    observer.observe(track);
    carousel.fpDestroy = function () {
      observer.disconnect();
      cancelAnimationFrame(pending);
    };
    update();
  });
}
initializeDemoCarousels();
document.addEventListener('shopify:section:load', initializeDemoCarousels);
document.addEventListener('shopify:section:unload', function (event) {
  event.target.querySelectorAll('[data-fp-carousel]').forEach(function (carousel) {
    if (carousel.fpDestroy) carousel.fpDestroy();
  });
});
